import withLocaleContext from 'hoc/withLocaleContext';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import { ExpandElement, List, TextContainer } from '../Footer.styles';

class StandardDataProcessingMelementsNote extends PureComponent<Partial<ILocaleContext>, { isOpened: boolean }> {
  constructor(props) {
    super(props);
    this.state = {
      isOpened: false,
    };
  }

  clickHandler = () => {
    this.setState(prevState => ({ isOpened: !prevState.isOpened }));
  };

  render() {
    const { isOpened } = this.state;
    const { formatMessage } = this.props;

    return (
      <div className="data-processing-notice melements-data-processing-notice">
        <TextContainer>
          <FormattedMessage id="footer.melements.dataProcessing1a" />
          <FormattedMessage id="footer.melements.dataProcessing1b" />
          {!isOpened && (
            <ExpandElement onClick={this.clickHandler}>
              <FormattedMessage id="footer.expand" />
            </ExpandElement>
          )}
        </TextContainer>

        {isOpened && (
          <div>
            <TextContainer>
              <FormattedMessage id="footer.melements.dataProcessing2" />
            </TextContainer>
            <TextContainer>
              <FormattedMessage id="footer.melements.dataProcessing3" />
            </TextContainer>
            <TextContainer>
              <FormattedMessage id="footer.melements.dataProcessing4" />
              <List>
                <li>
                  <FormattedMessage id="footer.melements.dataProcessing5" />
                </li>
                <li>
                  <FormattedMessage id="footer.melements.dataProcessing6" />
                </li>
              </List>
            </TextContainer>
            <TextContainer>
              <FormattedMessage id="footer.melements.dataProcessing7" />
            </TextContainer>
            <TextContainer>
              <FormattedMessage id="footer.melements.dataProcessing8" />
            </TextContainer>
            <TextContainer>
              <FormattedMessage id="footer.melements.dataProcessing9" />
              <a href={formatMessage && formatMessage({ id: `footer.uodoLink` })} target="_blank" rel="noreferrer">
                <FormattedMessage id="footer.uodoTxt" />
              </a>
              <FormattedMessage id="footer.melements.dataProcessing10" />
            </TextContainer>
            <TextContainer>
              <FormattedMessage id="footer.melements.dataProcessing11" />
              <a
                href={formatMessage && formatMessage({ id: `footer.melements.dataProcessing11.privacyPolicyLink` })}
                target="_blank"
                rel="noreferrer"
              >
                <FormattedMessage id="footer.melements.dataProcessing11.privacyPolicyTxt" />
              </a>
            </TextContainer>
            <TextContainer>
              <FormattedMessage id="footer.melements.dataProcessing12" />
              <a href="mailto:iod@melements.pl" target="_blank" rel="noreferrer">
                iod@melements.pl
              </a>
              {isOpened && (
                <ExpandElement onClick={this.clickHandler}>
                  <FormattedMessage id="footer.colapse" />
                </ExpandElement>
              )}
            </TextContainer>
          </div>
        )}
      </div>
    );
  }
}
export default withLocaleContext(StandardDataProcessingMelementsNote);
